// CSS Modules - component class name prefix: DownloadBox__

<template>
  <figure :class="$style.container">
    <img :src="downloadOptions[0].image" />
    <figcaption>
      <div :class="$style.title">
        <a
          v-if="downloadOptions[0].categoryLink"
          :href="downloadOptions[0].categoryLink"
          v-html="downloadOptions[0].title"
        ></a>
        <span v-else v-html="downloadOptions[0].title"></span>
      </div>
      <ul :class="$style.downloadList">
        <li
          v-for="(elm, index) in downloadOptions[0].downloadList"
          :key="index"
        >
          <a
            v-tippy="{
              theme: 'wika light tooltip',
              interactive: true,
              reactive: true,
              placement: 'top',
              flip: false,
              animation: 'perspective',
              animateFill: false,
              arrow: true,
              zIndex: 10000,
              html: '#downloadLinks-' + index,
              trigger: isMobileDevice ? 'click' : 'mouseenter focus'
            }"
            ref="tippy"
            @init="initTippy"
            @show="forceRerender"
          >
            <span :class="$style.triangle"></span>
            <span v-html="elm.title"></span>
          </a>
          <ul :id="'downloadLinks-' + index" :class="$style.downloadLinks">
            <li v-if="elm.pdf && !downloadOptions[0].noWishList">
              <WishListLink
                :key="`key-${componentKey}`"
                :config="{
                  text: labels.wishlist,
                  item: {
                    downloads: [{ url: elm.pdf }],
                    title: elm.title,
                    section: downloadOptions[0].title
                  }
                }"
              />
            </li>
            <li v-if="elm.pdf">
              <a :href="elm.pdf" target="_blank">
                <i class="fas fa-file-pdf"></i>{{ labels.pdf }}
              </a>
            </li>
            <li v-if="elm.ebook">
              <a :href="elm.ebook" target="_blank">
                <i class="fas fa-book"></i>{{ labels.ebook }}
              </a>
            </li>
            <li v-if="elm.docx">
              <a :href="elm.docx" target="_blank">
                <i class="fas fa-file-word"></i>{{ labels.docx }}
              </a>
            </li>
            <li v-if="elm.jpg">
              <a :href="elm.jpg" target="_blank">
                <i class="fas fa-file-image"></i>{{ labels.jpg }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </figcaption>
  </figure>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import WishListLink from "../WishListLink/WishListLink.vue";

export default {
  name: "DownloadBox",
  components: {
    WishListLink
  },
  props: {
    downloadOptions: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      componentKey: 0,
      isMobileDevice: isMobile
    };
  },
  methods: {
    initTippy(tippy) {
      tippy.popper.id = "downloadBoxPopper";
    },
    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style module lang="scss">
@import "./DownloadBox.scss";
</style>
